import { render, staticRenderFns } from "./media-info-icons.vue?vue&type=template&id=1cd9c8d4&lang=pug&"
import script from "./media-info-icons.vue?vue&type=script&lang=js&"
export * from "./media-info-icons.vue?vue&type=script&lang=js&"
import style0 from "./media-info-icons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cd9c8d4')) {
      api.createRecord('1cd9c8d4', component.options)
    } else {
      api.reload('1cd9c8d4', component.options)
    }
    module.hot.accept("./media-info-icons.vue?vue&type=template&id=1cd9c8d4&lang=pug&", function () {
      api.rerender('1cd9c8d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/media-info-icons.vue"
export default component.exports